import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

function Uploader() {
  const onDrop = useCallback(files => {
    console.log(files);
  }, []);
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop
  });
  return /*#__PURE__*/React.createElement("div", getRootProps(), /*#__PURE__*/React.createElement("input", getInputProps()), isDragActive ? /*#__PURE__*/React.createElement("p", null, "Soltar los archivos aqu\xED...") : /*#__PURE__*/React.createElement("p", null, "Arrastre y suelte algunos archivos aqu\xED, o haga clic para seleccionar archivos"));
}

export default Uploader;